import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ChatsPlaceholderIcon = (props: IconProps) => (
  <Icon width="374px" height="374px" viewBox="0 0 374 374" {...props}>
    <ellipse
      cx="184.359"
      cy="187.557"
      fill="#CCE4FF"
      opacity=".38"
      rx="179.859"
      ry="179.765"
    />
    <mask
      id="a"
      width="21"
      height="20"
      x="85"
      y="66"
      maskUnits="userSpaceOnUse"
    >
      <rect
        width="20.0462"
        height="18.9226"
        x="85.7987"
        y="66.7858"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M89.845 119.101h46.069V66.7858H89.845c8.8365 0 16 7.1634 16 16v20.3152c0 8.837-7.1635 16-16 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#fff"
      d="M105.845 66.7858h259.283c4.419 0 8 3.5817 8 8v41.8812c0 4.418-3.581 8-8 8H113.845c-4.418 0-8-3.582-8-8V66.7858Z"
    />
    <line
      x1="125.664"
      x2="353.309"
      y1="83.7084"
      y2="83.7084"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="125.664"
      x2="353.309"
      y1="94.8394"
      y2="94.8394"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="125.664"
      x2="181.803"
      y1="107.083"
      y2="107.083"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <mask
      id="b"
      width="21"
      height="20"
      x="85"
      y="257"
      maskUnits="userSpaceOnUse"
    >
      <rect
        width="20.0462"
        height="18.9226"
        x="85.7987"
        y="257.125"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M89.845 309.44h46.069v-52.315H89.845c8.8365 0 16 7.163 16 16v20.315c0 8.837-7.1635 16-16 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#fff"
      d="M105.845 257.125h259.283c4.419 0 8 3.582 8 8v41.881c0 4.418-3.581 8-8 8H113.845c-4.418 0-8-3.582-8-8v-49.881Z"
    />
    <line
      x1="125.664"
      x2="353.309"
      y1="274.048"
      y2="274.048"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="125.664"
      x2="353.309"
      y1="285.179"
      y2="285.179"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="125.664"
      x2="192.939"
      y1="297.423"
      y2="297.423"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <mask
      id="c"
      width="21"
      height="20"
      x="-4"
      y="162"
      maskUnits="userSpaceOnUse"
    >
      <rect
        width="20.0463"
        height="18.9226"
        x="-3.29578"
        y="162.512"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#c)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M.750504 214.827H46.8199v-52.315H.750488c8.836552 0 16.000012 7.163 16.000012 16v20.315c0 8.837-7.16344 16-15.999996 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#fff"
      d="M16.7505 162.512H276.034c4.418 0 8 3.582 8 8v41.881c0 4.418-3.582 8-8 8H24.7505c-4.4183 0-8-3.582-8-8v-49.881Z"
    />
    <line
      x1="36.5693"
      x2="264.215"
      y1="179.435"
      y2="179.435"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="36.5693"
      x2="264.215"
      y1="190.566"
      y2="190.566"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="36.5693"
      x2="188.485"
      y1="202.81"
      y2="202.81"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <ellipse
      cx="23.4325"
      cy="222.619"
      fill="#66AFFF"
      rx="13.3642"
      ry="13.3571"
    />
    <path
      fill="#fff"
      d="M16.2864 228.463h2.5986v-7.792h-2.5986v7.792Zm14.2922-7.143c0-.714-.5847-1.298-1.2993-1.298H25.18l.6172-2.968.0195-.207c0-.266-.1104-.513-.2858-.689l-.6887-.681-4.2746 4.279c-.2404.233-.3833.558-.3833.915v6.493c0 .714.5846 1.299 1.2993 1.299h5.8468c.5392 0 1.0004-.325 1.1953-.792l1.962-4.578c.0584-.149.0909-.305.0909-.474v-1.299Z"
    />
    <rect
      width="56.7977"
      height="20.0357"
      x="249.51"
      y="31.1667"
      fill="#66AFFF"
      rx="10.0179"
    />
    <ellipse
      cx="260.647"
      cy="41.1845"
      fill="#CCE4FF"
      rx="3.34105"
      ry="3.33929"
    />
    <ellipse
      cx="271.783"
      cy="41.1845"
      fill="#CCE4FF"
      rx="3.34105"
      ry="3.33929"
    />
    <ellipse
      cx="282.92"
      cy="41.1845"
      fill="#CCE4FF"
      rx="3.34103"
      ry="3.33929"
    />
    <ellipse
      cx="294.057"
      cy="41.1845"
      fill="#CCE4FF"
      rx="3.34103"
      ry="3.33929"
    />
    <mask
      id="d"
      width="73"
      height="72"
      x="16"
      y="51"
      maskUnits="userSpaceOnUse"
    >
      <ellipse
        cx="52.3883"
        cy="86.8214"
        fill="#E5F2FF"
        rx="35.6378"
        ry="35.619"
      />
    </mask>
    <g clipPath="url(#e)" mask="url(#d)">
      <rect
        width="104.877"
        height="221.856"
        fill="#E5F2FF"
        transform="translate(-.559448 45.0962)"
      />
      <g clipPath="url(#f)">
        <path
          fill="#fff"
          d="M40.1424 104.176s-11.2065 7.61-14.4373 40.354c-2.2652 22.938-4.2204 30.999-4.2204 30.999l6.6047.095s12.9114-32.127 14.0797-46.385c.5484-6.732-2.0267-25.051-2.0267-25.051v-.012ZM64.2603 103.879s13.0067 5.058 15.856 39.725c1.8837 22.961 3.8269 31.925 3.8269 31.925l-6.6047.095s-12.9113-32.127-14.0797-46.385c-.5484-6.732 1.0134-25.36 1.0134-25.36h-.0119Z"
        />
        <path
          fill="#fff"
          d="M48.7858 101.434c-4.2203.261-8.8698.997-10.1693 5.39-.8703 5.983 2.0028 25.11-1.6333 44.675-5.1145 27.544-4.0177 57.392-4.0177 57.392l40.3316.296s.5127-30.132-3.6242-57.391c-2.8017-18.449-.4769-36.662-3.0878-44.984-1.371-4.381-7.9638-4.809-10.2051-5.378-2.7062-1.128-4.0057-.226-7.5942 0Z"
        />
        <path
          fill="#323232"
          d="M77.5651 75.6587c0 13.9381-11.3496 25.2403-25.3458 25.2403-13.9963 0-25.3459-11.3022-25.3459-25.2403 0-13.9382 11.3496-25.2407 25.3459-25.2407 13.9962 0 25.3458 11.3025 25.3458 25.2407Z"
        />
        <path
          fill="#323232"
          d="M44.5535 86.2132s-.9538-5.2476.7391-8.4888c2.1221-4.0722 8.4526-6.3161 13.3286-1.9827 3.3978 3.0156 1.6095 10.982 1.6095 10.982L49.5964 82.224l-5.0429 3.9773v.0119Z"
        />
        <path
          fill="#29374F"
          d="M56.38 101.434s-4.4588 2.35-7.5942 0l.6676-8.1449h6.259l.6676 8.1449ZM45.8887 85.299s-.8941-.5817-1.5975.3443c-.6915.9261-.2265 4.3809 1.5021 4.3809 1.7287 0 .0835-4.7252.0835-4.7252h.0119ZM59.3246 85.299s.8942-.5817 1.5975.3443c.6915.9261.2385 4.3809-1.5021 4.3809s-.0835-4.7252-.0835-4.7252h-.0119Z"
        />
        <path
          fill="#2F3D5B"
          d="M59.6108 84.3374c0-3.8823-3.1474-6.423-7.0339-6.423s-7.0339 2.5407-7.0339 6.423c0 0-.31 4.9508-.31 5.2001 0 3.6923 4.5423 8.37 7.3439 8.37 3.2427 0 7.3438-5.58 7.3438-8.37 0-.2374-.3099-5.2001-.3099-5.2001Z"
        />
        <path
          fill="#fff"
          d="M45.7337 92.1851s.0954-.0238.1431-.0475l-.1669-.4037s-.0596.0237-.0835.0237c-.7749.2137-1.5856-.2493-1.8002-1.0329-.2146-.7717.2504-1.579 1.0372-1.7927l-.1073-.4155c-1.0133.273-1.6213 1.3178-1.3471 2.3151.2742 1.0092 1.3233 1.6028 2.3367 1.3416l-.012.0119ZM59.3484 92.185s-.1073-.0356-.1669-.0593c.0477.0118.1788-.3918.1788-.3918.0358 0 .0716.0237.0954.0356.7749.2137 1.5856-.2493 1.8002-1.0329.2146-.7717-.2503-1.579-1.0372-1.7927l.1073-.4156c1.0134.2731 1.6095 1.3179 1.3472 2.3151-.2742 1.0092-1.3233 1.6028-2.3367 1.3416h.0119Z"
        />
      </g>
    </g>
    <mask
      id="g"
      width="72"
      height="72"
      x="287"
      y="153"
      maskUnits="userSpaceOnUse"
    >
      <ellipse
        cx="323.013"
        cy="189.226"
        fill="#FFFAE5"
        rx="35.6378"
        ry="35.619"
      />
    </mask>
    <g clipPath="url(#h)" mask="url(#g)">
      <rect
        width="157.825"
        height="216.767"
        fill="#FFFAE5"
        transform="translate(204.899 148.519)"
      />
      <path
        fill="#FFEACC"
        d="M321.354 167.224c-5.76.056-12.929 3.115-12.088 12.594.589 6.642 2.19 18.009 6.56 18.362 1.933.157 8.559-2.256 8.559-2.256l.553 7.935 12.431-3.276-4.879-10.287s7.844-23.253-11.136-23.066v-.006Z"
      />
      <path
        fill="#323232"
        d="m311.219 171.172 11.318 9.872c.735-3.099 3.106-2.957 4.833-1.065 2.125 2.332-.463 5.487.076 6.32.543.827 4.304 4.078 5.034 3.992.735-.086 12.622-9.802 2.346-23.662-4.737-6.39-17.681-5.653-23.612 4.543h.005Z"
      />
      <path
        fill="#323232"
        d="M316.868 156.827c.131 4.558 3.051 7.319 7.189 7.202 4.134-.116 5.936-3.149 5.81-7.707-.131-4.558-2.406-7.919-6.545-7.803-4.138.116-6.585 3.745-6.454 8.303v.005Z"
      />
      <path
        fill="#fff"
        d="M326.217 207.382c-7.808.671-9.777 19.478-1.218 53.796l-32.629 11.659 5.452 5.598s33.858-1.075 39.421-13.492c5.563-12.417 3.373-58.798-11.026-57.561Z"
      />
      <path
        fill="#fff"
        d="m321.439 199.71 39.678-9.747s8.06 25.197-11.912 26.373c-19.967 1.181-27.761-16.626-27.761-16.626h-.005Z"
      />
      <path
        fill="#fff"
        d="M332.274 198.448c5.709.353 11.318 1.741 14.998 12.543 5.246 14.88 8.956 40.808 9.092 90.016l-46.57-17.469c4.798-25.217 2.84-75.742 11.645-83.823 3.661-1.545 5.987-1.565 10.835-1.262v-.005Z"
      />
      <path
        fill="#fff"
        d="M334.972 209.184c-7.833.02-9.777 19.478-1.218 53.795l-26.86 9.04-.317 8.223s33.858-.132 39.421-12.548c5.563-12.417-1.953-58.525-11.026-58.505v-.005Z"
      />
    </g>
    <mask
      id="i"
      width="72"
      height="72"
      x="11"
      y="268"
      maskUnits="userSpaceOnUse"
    >
      <ellipse
        cx="46.8199"
        cy="303.875"
        fill="#FEEFEA"
        rx="35.6378"
        ry="35.619"
      />
    </mask>
    <g clipPath="url(#j)" mask="url(#i)">
      <rect
        width="154.77"
        height="316.501"
        fill="#FEEFEA"
        transform="translate(-30.5652 265.203)"
      />
      <path
        fill="#F7A283"
        d="M51.7937 266.799c7.0567.266 15.1491 7.669 14.3847 15.769-.7644 8.099-3.2957 21.889-8.6629 22.166-2.3762.127-10.4077-3.039-10.4077-3.039l-.9527 9.657-15.1214-4.42 6.3255-12.381s-8.818-28.624 14.4345-27.752Z"
      />
      <path
        fill="#fff"
        d="M55.311 278.308c-3.3732 4.768-3.8164 13.077-5.4393 5.304-.792-3.801-3.7111-3.713-5.8879-1.459-2.6809 2.774.3822 6.702-.3102 7.702-.6923.995-5.4115 4.823-6.3089 4.696-.8973-.127-5.3007-16.359 1.1078-24.492 7.0124-8.9 24.3881-4.519 25.8171 4.763-1.4512-.448-5.6386-1.221-8.9731 3.491l-.0055-.005Z"
      />
      <path
        fill="#041723"
        d="M37.5309 304.629c-6.9957.436-13.4541 7.713-17.9629 20.895-3.4618 23.768-10.10303 107.145-10.10303 107.145H72.875S64.2343 319.275 51.7273 309.64c-4.9685-4.055-8.2531-5.376-14.2019-5.011h.0055Z"
      />
      <path
        fill="#041723"
        d="M37.4754 316.761c9.2335 2.652 8.2752 19.984-10.1418 59.029l27.3403 39.823-10.9948 9.774s-31.3616-27.741-35.11707-43.918c-3.75542-16.177 11.88107-69.592 28.90787-64.708h.0055Z"
      />
    </g>
    <defs>
      <clipPath id="e">
        <rect
          width="104.877"
          height="221.856"
          fill="#fff"
          transform="translate(-.559448 45.0962)"
        />
      </clipPath>
      <clipPath id="f">
        <rect
          width="62.4585"
          height="216.339"
          fill="#fff"
          transform="translate(21.4847 50.418)"
        />
      </clipPath>
      <clipPath id="h">
        <rect
          width="157.825"
          height="216.767"
          fill="#fff"
          transform="translate(204.899 148.519)"
        />
      </clipPath>
      <clipPath id="j">
        <rect
          width="154.77"
          height="316.501"
          fill="#fff"
          transform="translate(-30.5652 265.203)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ChatsPlaceholderIcon);
